import { Base } from "./base";

export class Sensor extends Base {
    SensorID?: string;
    AuthorID?: string;
    RegistrationNumber?: string;
    CreateDate?: Date;
    IsDeleted?: boolean;

    // Model properties
    Author?: string;
    ParkingID?: number;

    // Web properties
    IsEditable?: boolean;
}